import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private mvar_isSys: boolean; // 是否系统运营租户
  private mvar_isTenantID: string;
  private mvar_isTenantCode: string;
  private mvar_isTenantName: string;
  private mvar_isExpDate: string; // 过期时间
  private mvar_isLock: string; // 是否锁定
  private mvar_HaveNums: number; // 剩余次数
  private mvar_TotalNums: number; // 累计测试次数

  constructor() {}

  setTenantInfo(tenant_data) {
    this.mvar_isSys = tenant_data.is_sys;
    this.mvar_isTenantID = tenant_data.id;
    this.mvar_isTenantCode = tenant_data.tenant_code;
    this.mvar_isTenantName = tenant_data.tenant_name;
    this.mvar_isExpDate = tenant_data.exp_date;
    this.mvar_isLock = tenant_data.islock;
    this.mvar_HaveNums = tenant_data.have_nums;
    this.mvar_TotalNums = tenant_data.total_nums;
  }

  getTenantInfo() {
    const tenant_data: any = {};
    tenant_data.is_sys = this.mvar_isSys;
    tenant_data.id = this.mvar_isTenantID;
    tenant_data.tenant_code = this.mvar_isTenantCode;
    tenant_data.tenant_name = this.mvar_isTenantName;
    tenant_data.exp_date = this.mvar_isExpDate;
    tenant_data.islock = this.mvar_isLock;
    tenant_data.have_nums = this.mvar_HaveNums;
    tenant_data.total_nums = this.mvar_TotalNums;
    return tenant_data;
  }

  getID() {
    return this.mvar_isTenantID;
  }

  getTenantName() {
    return this.mvar_isTenantName;
  }

  getTenantCode() {
    return this.mvar_isTenantCode;
  }
}
